const labels = {
    vi: {
        ginId: 'Mã sâm',
        ginName: 'Tên sâm',
        linkedProduct: 'Sản phẩm liên kết',
        dateCreated: 'Ngày tạo',
        tableTitle: 'Danh sách sâm',
        source: 'Nguồn gốc',
        unit: 'loại sâm',
        add: 'Thêm',
        cancel: 'Hủy',
        update: 'Cập nhật',
        createGinseng: 'Tạo sâm mới',
        certificateOfGinseng: 'Giấy chứng nhận',
        requiredCode: 'Mã không được để trống',
        requiredName: 'Tên không được để trống',
        requiredDate: 'Ngày không được để trống',
        requiredSource: 'Nguồn gốc không được để trống',
        requiredUseOf: 'Tác dụng không được để trống',
        requiredAvatar: 'Hình ảnh không được để trống',
        requiredFile: 'Yêu cầu có giấy chứng nhận sâm',
        updateGinseng: 'Chỉnh sửa Sâm',
        chooseFile: 'Tải giấy chứng nhận lên',
        useOfGinseng: 'Tác dụng của Sâm',
        AnotherInformation: 'Thông tin khác (nếu có)',
        inputCode: 'Nhập mã sâm',
        inputName: 'Nhập tên sâm',
        inputSource: 'Nhập nguồn gốc sâm',
        inputEffect: 'Nhập các tác dụng khác của sâm tại đây',
        inputAnotherInformation: 'Nhập các thông tin khác của sâm tại đây',
        avatarGinseng: 'Hình ảnh sâm (tối đa 5 ảnh)',
        addSuccess: 'Thêm sâm thành công',
        addFail: 'Thêm sâm thất bại',
        updateSuccess: 'Chỉnh sửa thành công',
        updateFail: 'Chỉnh sửa thất bại',
        deleteSuccess: 'Xoá sâm thành công!',
        deleteFail: 'Xoá sâm thất bại!',
        addImageFail: 'Thêm ảnh thất bại',
        updateImageFail: 'Cập nhật ảnh thất bại',
        generalInformation: 'Thông tin chung',
        generalDetail: 'Thông tin chi tiết',
        ConfirmDeleteTitle: "Bạn có muốn xoá dữ liệu",
        ConfirmDeleteText: "Vui lòng xác nhận",
        ConfirmDeleteYes: "Xoá",
        ConfirmDeleteNo: "Huỷ",
    },
    en: {
        ginId: 'Gin code',
        ginName: 'Gin name',
        dateCreated: 'Date created',
        linkedProduct: 'Liked product',
        tableTitle: 'Ginseng List',
        source: 'Source',
        unit: 'types of ginseng',
        add: 'Add',
        cancel: 'Cancel',
        update: 'Update',
        createGinseng: 'Create new Ginseng',
        requiredCode: 'Code is required',
        requiredName: 'Name is required',
        requiredDate: 'Date is required',
        requiredSource: 'Source is required',
        requiredUseOf: 'Use of Ginseng is required',
        requiredAvatar: 'Avatar is required',
        requiredFile: 'File certificate is required',
        certificateOfGinseng: 'Certificate of Ginseng',
        updateGinseng: 'Update Ginseng',
        chooseFile: 'Choose file certificate of ginseng',
        useOfGinseng: 'Use of ginseng',
        AnotherInformation: 'Another information (if any)',
        inputCode: 'Enter ginseng code',
        inputName: 'Enter ginseng name',
        inputSource: 'Enter ginseng source',
        inputEffect: 'Enter other effects of ginseng here',
        inputAnotherInformation: 'Enter other information of ginseng here',
        avatarGinseng: 'Ginseng image (limited 5 pictures)',
        addSuccess: 'Add ginseng success',
        addFail: 'Add ginseng fail',
        updateSuccess: 'Update ginseng success',
        updateFail: 'Update ginseng fail',
        deleteSuccess: 'Delete ginseng success!',
        deleteFail: 'Delete ginseng fail!',
        addImageFail: 'Add image fail!',
        updateImageFail: 'Update image fail!',
        generalInformation: 'General information',
        generalDetail: 'General detail',
        ConfirmDeleteTitle: "You want delete data",
        ConfirmDeleteText: "Please confirm",
        ConfirmDeleteYes: "Delete",
        ConfirmDeleteNo: "Cancel",
    },
};

export default labels;
